import gql from 'graphql-tag';
import FieldsFloor from "graphql/fields/FieldsFloor";
import FieldsTimeslot from "graphql/fields/FieldsTimeslot";
import HelperGraphql from 'utils/helper-graphql'

const fields = {
	'kind': 'String',
	'sub_kind': 'String',
	'timeslot_day': '[Int]',
};

export default gql(`
	query floors( ${ HelperGraphql.createFields( fields ) } ) {
		floors {
			${FieldsFloor}
	        
	        rooms {
				guid
			}
			
			building {
				guid
			}
			
			lunch_options {
	            lunch_option {
	                guid
	            }
	        }
	        
	        timeslots_through( ${ HelperGraphql.createVariables( fields ) } ) {
                ${FieldsTimeslot}
            }
		}
	}
`);

